export default "__VITE_ASSET__f5417653__"